<template>
    <span class="pointer-text" @click="handle()">{{text}}</span>
</template>

<script>
    export default {
        name: "LinkText",
        props: ["text"],
        methods: {
            handle: function (item) {
                this.$emit('click');
            }
        }
    }
</script>